import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import { TakeAssessment } from "../component/features/take-assessments/TakeAssessment";
import Header from "../component/layouts/Header";
import ResponderDetailForm from "../component/features/take-assessments/ResponderDetailForm";

const dimensions = {
    HEADER: { value: 4, measuredIn: 'rem' },
};

export class PublicRouter extends Component {
    
    render() {
        return (
            <div className="d-flex h-100 w-100">
                <Header {...this.props} />
                <div style={{
                    paddingTop: dimensions.HEADER.value + dimensions.HEADER.measuredIn,
                    width:"100%"
                }}>
                    <Switch>
                        <Route exact path={"/public/take-assessments/:token"} component={TakeAssessment} />
                        <Route exact path={"/public/responder/:token"} component={ResponderDetailForm} />
                        {/* <Redirect to="/not-found" /> */}
                    </Switch>
                </div>
            </div>
        )
    }
};